import { Toaster as Sonner, toast } from "sonner"
import { cn } from "@/lib/utils"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: cn(
            "group toast",
            "group-[.toaster]:bg-gradient-to-br group-[.toaster]:from-gray-900/90 group-[.toaster]:via-gray-900/85 group-[.toaster]:to-gray-800/80",
            "group-[.toaster]:backdrop-blur-2xl group-[.toaster]:text-gray-100 group-[.toaster]:border-white/10",
            "group-[.toaster]:shadow-[0_8px_32px_rgba(0,0,0,0.5),0_2px_8px_rgba(0,0,0,0.3),inset_0_1px_0_rgba(255,255,255,0.08),inset_0_-1px_0_rgba(255,255,255,0.02)]",
            "group-[.toaster]:rounded-2xl"
          ),
          description: "group-[.toast]:text-[13px] group-[.toast]:text-gray-400",
          actionButton: cn(
            "group-[.toast]:bg-white/10 group-[.toast]:text-gray-200 group-[.toast]:font-semibold",
            "group-[.toast]:border group-[.toast]:border-white/10",
            "group-[.toast]:hover:bg-white/15 group-[.toast]:hover:text-white",
            "group-[.toast]:rounded-xl group-[.toast]:h-9 group-[.toast]:px-4"
          ),
          cancelButton: cn(
            "group-[.toast]:bg-white/5 group-[.toast]:text-gray-400",
            "group-[.toast]:border group-[.toast]:border-white/10",
            "group-[.toast]:rounded-xl group-[.toast]:h-9 group-[.toast]:px-4"
          ),
          error: cn(
            "group-[.toaster]:!to-red-950/30 group-[.toaster]:border-red-500/20",
            "group-[.toaster]:shadow-[0_8px_32px_rgba(0,0,0,0.5),0_2px_8px_rgba(0,0,0,0.3),0_0_24px_rgba(239,68,68,0.08),inset_0_1px_0_rgba(255,255,255,0.06)]"
          ),
          success: cn(
            "group-[.toaster]:!to-emerald-950/30 group-[.toaster]:border-emerald-500/20",
            "group-[.toaster]:shadow-[0_8px_32px_rgba(0,0,0,0.5),0_2px_8px_rgba(0,0,0,0.3),0_0_24px_rgba(16,185,129,0.08),inset_0_1px_0_rgba(255,255,255,0.06)]"
          ),
          warning: cn(
            "group-[.toaster]:!to-amber-950/30 group-[.toaster]:border-amber-500/20",
            "group-[.toaster]:shadow-[0_8px_32px_rgba(0,0,0,0.5),0_2px_8px_rgba(0,0,0,0.3),0_0_24px_rgba(245,158,11,0.08),inset_0_1px_0_rgba(255,255,255,0.06)]"
          ),
          info: cn(
            "group-[.toaster]:!to-purple-950/30 group-[.toaster]:border-purple-500/20",
            "group-[.toaster]:shadow-[0_8px_32px_rgba(0,0,0,0.5),0_2px_8px_rgba(0,0,0,0.3),0_0_24px_rgba(168,85,247,0.08),inset_0_1px_0_rgba(255,255,255,0.06)]"
          ),
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
